// src/pages/about/ceomessage/ceomessage.js

import React, { useEffect, useRef } from "react";
import "./ceomessage.css";
import { Sparkles, Quote, ArrowRight, ShieldCheck, Target, Heart } from "lucide-react";
import { Link } from "react-router-dom";
import shriKrishanImg from "../../assets/OIP.jpg.jpeg";

export default function CEOMessage() {
  const pageRef = useRef(null);

  // Scroll to top on load and scroll-in animations
  useEffect(() => {
    window.scrollTo(0, 0);

    const targets = pageRef.current ? pageRef.current.querySelectorAll(".cm-reveal") : [];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cm-shown");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="ceo-message-page" ref={pageRef}>
      {/* Background patterns */}
      <div className="cm-bg-pattern" />
      <div className="cm-blob cm-blob-1" />
      <div className="cm-blob cm-blob-2" />

      {/* Hero Header */}
      <section className="cm-hero cm-reveal">
        <div className="cm-container">
          <span className="cm-badge">
            <Sparkles size={13} /> Leadership Message
          </span>
          <h1>A Word From Our CEO</h1>
          <p className="cm-hero-subtitle">
            Sustaining growth, developing top-tier talent, and engineering next-generation digital platforms for modern enterprises.
          </p>
          <div className="cm-hero-line"></div>
        </div>
      </section>

      {/* Main Content Layout */}
      <section className="cm-main-section">
        <div className="cm-container">
          <div className="cm-grid">

            {/* Left Column: CEO Profile Card */}
            <div className="cm-profile-col cm-reveal">
              <div className="cm-profile-card">
                <div className="cm-img-wrapper">
                  <img
                    src={shriKrishanImg}
                    alt="SHRI KRISHAN"
                    className="cm-ceo-photo"
                  />
                  <div className="cm-photo-accent" />
                </div>
                <div className="cm-profile-info">
                  <h3>SHRI KRISHAN</h3>
                  <p className="cm-ceo-title">Founder &amp; CEO, EduITalent</p>

                  <div className="cm-divider"></div>

                  <div className="cm-profile-quote">
                    <Quote size={20} className="cm-quote-icon" />
                    <p>Retired from BEL, Ghaziabad. 40+ years of experience in handling highly paid radar painting projects across India.</p>
                  </div>

                  {/* Operational Networks */}
                  <div className="cm-ceo-networks">
                    <div className="network-item">
                      <span className="net-dot blue" /> Noida HQ Network
                    </div>
                    <div className="network-item">
                      <span className="net-dot purple" /> Globe Offshore Desk
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Message Content */}
            <div className="cm-content-col cm-reveal">
              <div className="cm-message-wrapper">
                <div className="cm-message-header">
                  <Quote size={40} className="cm-large-quote" />
                  <h2>Driving Recruitment &amp; Consultancy Excellence</h2>
                </div>

                <div className="cm-message-body">
                  <p className="cm-lead-para">
                    Dear Valued Clients and Partners,
                  </p>

                  <p>
                    As the CEO of Eduitalent, I am proud to lead a team of dedicated professionals who are committed to providing the highest quality recruitment and consultancy services to our clients.
                  </p>

                  <p>
                    Our goal is to help businesses achieve their recruitment and consultancy goals by providing expert guidance and support every step of the way. We understand that finding the right talent is critical to the success of any organization, and we take pride in our ability to deliver tailored solutions that meet our clients’ specific needs.
                  </p>

                  <p>
                    At Eduitalent, we specialize in matching skills with client requirements, providing resources from entry to top management level. We also offer certificate courses and training programs in IT and Human Resources Management, helping professionals and students develop and nurture their skills.
                  </p>

                  <p>
                    Our experienced recruiters have a deep understanding of the industry and stay up-to-date with the latest trends and technologies in their respective fields. They work closely with our clients to identify their specific requirements and attract the best talent to the organization.
                  </p>

                  <p>
                    We are committed to building long-term relationships with our clients and partners. We believe that effective communication and collaboration are key to achieving mutual success. We are always open to feedback and suggestions on how we can improve our services and better serve your needs.
                  </p>

                  <p>
                    Thank you for choosing Eduitalent as your recruitment and consultancy partner. We are honored to work with you and look forward to helping you achieve your goals.
                  </p>

                  <div className="cm-signature-block">
                    <div className="cm-sig-line">Mr. Krishan</div>
                    <p className="cm-sig-name">Mr. Krishan</p>
                    <p className="cm-sig-lbl">Founder &amp; CEO, EduITalent</p>
                  </div>
                </div>
              </div>

              {/* CEO Focus Cards */}
              <div className="cm-focus-grid">
                <div className="cm-focus-card">
                  <div className="cm-focus-icon blue"><ShieldCheck size={20} /></div>
                  <h4>Compliance First</h4>
                  <p>Absolute transparency in statutory audits, ESI/PF processing, and corporate governance.</p>
                </div>
                <div className="cm-focus-card">
                  <div className="cm-focus-icon purple"><Target size={20} /></div>
                  <h4>Customer Centered</h4>
                  <p>Direct engagement with leadership to customize staff provisioning and tech deliveries.</p>
                </div>
                <div className="cm-focus-card">
                  <div className="cm-focus-icon green"><Heart size={20} /></div>
                  <h4>Talent Development</h4>
                  <p>Upskilling entry and mid-level personnel to align with enterprise expectations.</p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="cm-cta-section cm-reveal">
        <div className="cm-container">
          <div className="cm-cta-card">
            <h2>Ready to discuss your enterprise requirements?</h2>
            <p>Connect with our leadership team for custom staffing, compliant payroll models, or software consultation.</p>
            <div className="cm-cta-btns">
              <Link to="/contact" className="cm-btn-primary">
                Schedule Executive Call <ArrowRight size={16} />
              </Link>
              <Link to="/about" className="cm-btn-secondary">
                Back to About Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
